import React from 'react';

import { SectionToggler } from '@/components/modals/SubmitOrder/components/OrderInfoStep/components/SectionToggler';

import styles from './YesNoQuestion.module.scss';

type Props = {
  question: string;
  answer: boolean | null;
  setAnswer: (value: boolean) => void;
};

export const YesNoQuestion = ({ question, answer, setAnswer }: Props) => {
  return (
    <div className={styles.question_wrapper}>
      <span className={styles.question}>{question}</span>

      <section className={styles.toggler_wrapper}>
        <SectionToggler enabled={answer} name={question} onToggle={setAnswer} />
      </section>
    </div>
  );
};
